import * as React from "react";
import { connect } from "react-redux";
import * as Actions from "../../../redux/actions";
import { AppState } from "../../../redux";
import { Person } from "@radivision/graphql/lib/ts/graphql/person";
import { RdvButton } from "../../page-framework/rdv-button";
import { ChangeEmailRequestAction, ChangeEmailRequestPayload } from "../../../redux/account/types";
import { ChangeEmailVerificationModal } from "./change-email-verification-modal";

interface MapDispatchProps {
  changeEmailRequest: (payload: ChangeEmailRequestPayload) => ChangeEmailRequestAction;
}

interface MapStateProps {
  user: Person | null;
  inProgress: boolean;
}

export type Props = MapDispatchProps & MapStateProps;

interface State {
  email: string | null;
}

class Component extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      email: null,
    };
  }
  onSubmit(currentEmail: string) {
    const { email } = this.state;

    this.props.changeEmailRequest({ email, currentEmail });
  }

  render() {
    const { inProgress, user } = this.props;
    const { email } = this.state;
    const emailAddress = user?.emailAddresses[0];
    return (
      <div id="change-email" className="settings-section">
        <h4>Email Address</h4>
        <p>Current Email Address: {emailAddress}</p>
        <div className="form-group">
          <label className="has-float-label top">Change Email Address</label>
          <input
            className="form-control form-control-lg-7"
            id="createAccountPassword"
            type="text"
            value={email}
            onChange={(e) => this.setState({ email: e.target.value?.toLowerCase() })}
            placeholder="Enter new email address"
            required={true}
            disabled={false}
          />
        </div>
        <RdvButton
          form="change-email-form"
          text="Request changing email"
          isLoading={inProgress}
          disabled={false}
          onClick={() => {
            this.onSubmit(emailAddress);
          }}
        />
        <ChangeEmailVerificationModal email={email} />
      </div>
    );
  }
}

const mapState = (state: AppState) => ({
  user: state.account.user,
  inProgress: state.cache.inProgress["change-email"],
});

const mapDispatch = {
  changeEmailRequest: Actions.changeEmailRequest,
};

export const ChangeEmail = connect(mapState, mapDispatch)(Component);
